import {Component} from '@angular/core';


@Component({
    selector: 'tfl-bo-card-box-header',
    template: `
        <ng-content select=".card-box-header-icon"></ng-content>
       
        <ng-content select=".card-box-header-title"></ng-content>

        <ng-content select=".card-box-header-content"></ng-content>
    `
})
export class CardBoxHeaderComponent {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/card-box/card-box.header.component.ts